import { Group, Space, Stack } from "@mantine/core";
import { Text } from "./ui/Text";
import { useStyles } from "@/styles/useStyles";
import {
  useDidCheckStandaloneSeatAccess,
  useIsStandaloneSeatAccessLocked,
} from "@/store/selectors/assignmentSelectors";
import { useIsPartnerApp } from "@/store/selectors/featureSelectors";

// deploy 1
export const Banner = () => {
  const { theme } = useStyles();
  const isStandaloneSeatAccessLocked = useIsStandaloneSeatAccessLocked();
  const didCheckStandaloneSeatAccess = useDidCheckStandaloneSeatAccess();
  const isPartnerApp = useIsPartnerApp();

  if (
    !didCheckStandaloneSeatAccess ||
    !isStandaloneSeatAccessLocked ||
    !isPartnerApp
  )
    return null;

  return (
    <Group
      w="100vw"
      px="md"
      py="xs"
      justify="center"
      align="center"
      ta="center"
      c="white"
      style={{
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        background: theme.colors.primary[9],
        borderTop: `2px solid ${theme.colors.primary[4]}`,
        boxShadow: `0 -6px 16px ${theme.colors.primary[9]}`,
      }}
    >
      <Stack gap={0} w="100%" py="sm">
        <Text titleStyle="h2" fw={800} c="white">
          Assignment delivery is not enabled yet
        </Text>
        <Text size="md" c="white" fw={500}>
          You can create assignments, but students will not be able to use them
          until seats are allocated for your account.
        </Text>
        <Space h="sm" />
        <Text size="md" c="white" fw={800} mt={4} mb={2}>
          <a
            href="https://buy.stripe.com/dRmbJ13JO5Xbcv0gRx4Vy01"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              padding: "12px 28px",
              borderRadius: 9999,
              background: "#E6580E",
              color: "white",
              textDecoration: "none",
              fontWeight: 800,
              fontSize: "16px",
              lineHeight: 1.1,
              boxShadow: "0 6px 14px rgba(0, 0, 0, 0.25)",
            }}
          >
            Buy Seats - $20/student
          </a>
        </Text>
        <Space h="xs" />
        <Text size="sm" c="white" fw={500} style={{ opacity: 0.75 }}>
          Contact Sales:{" "}
          <a
            href="mailto:hello@advizehub.com"
            style={{
              color: theme.colors.primary[2],
              textDecoration: "underline",
            }}
          >
            hello@advizehub.com
          </a>
        </Text>
      </Stack>
    </Group>
  );
};
